// extracted by mini-css-extract-plugin
module.exports = {"btn":"HJa1"};